import React from 'react'
import Section from '../../common/components/Section'
import Ads from '../../common/components/Ads'

function SectionAds() {
  return (
    <Section padding="1rem 9rem">
      <Ads />
    </Section>
  )
}

export default SectionAds
